/**
 * LazyLoader - Componente de loading suave para Suspense
 * Exibe skeleton/spinner durante carregamento de componentes lazy
 */
import React from 'react';

const LazyLoader = ({ 
  height = 'h-64', 
  text = 'Carregando...', 
  showText = true,
  variant = 'default' // 'default' | 'card' | 'page' | 'inline'
}) => {
  if (variant === 'inline') {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="w-5 h-5 border-2 border-[#4A90B2] border-t-transparent rounded-full animate-spin" />
        {showText && <span className="ml-2 text-sm text-slate-500">{text}</span>}
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-100 animate-pulse">
        <div className="h-4 bg-slate-200 rounded w-3/4 mb-4" />
        <div className="h-3 bg-slate-200 rounded w-1/2 mb-2" />
        <div className="h-3 bg-slate-200 rounded w-2/3" />
      </div>
    );
  }

  if (variant === 'page') {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-slate-200 rounded-full" />
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-[#4A90B2] border-t-transparent rounded-full animate-spin" />
        </div>
        {showText && (
          <p className="mt-4 text-slate-500 animate-pulse">{text}</p>
        )}
      </div>
    );
  }

  // Default variant
  return (
    <div className={`flex flex-col items-center justify-center ${height} bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl`}>
      <div className="relative">
        <div className="w-12 h-12 border-4 border-slate-200 rounded-full" />
        <div className="absolute top-0 left-0 w-12 h-12 border-4 border-[#4A90B2] border-t-transparent rounded-full animate-spin" />
      </div>
      {showText && (
        <p className="mt-3 text-sm text-slate-500 animate-pulse">{text}</p>
      )}
    </div>
  );
};

// Variantes pré-configuradas para uso comum
export const PageLoader = () => <LazyLoader variant="page" text="Carregando página..." />;
export const CardLoader = () => <LazyLoader variant="card" />;
export const InlineLoader = ({ text }) => <LazyLoader variant="inline" text={text} />;
export const ChatLoader = () => <LazyLoader height="h-96" text="Carregando chat..." />;
export const CalendarLoader = () => <LazyLoader height="h-80" text="Carregando calendário..." />;
export const PaymentLoader = () => <LazyLoader height="h-48" text="Preparando pagamento..." />;
export const DashboardLoader = () => <LazyLoader variant="page" text="Carregando painel..." />;

export default LazyLoader;
